import axios from 'axios';
import getAuthBaseUrl from './authBaseUrl';
import { VITE_AUTH_HEADER_PREFIX, VITE_GP_VERSION } from 'Constants/appEnvConstants';

const baseUrl = getAuthBaseUrl();


export async function getUserHierarchyData(authToken,hierarchyId){
  axios.defaults.headers.common.Authorization = VITE_AUTH_HEADER_PREFIX + authToken;
  axios.defaults.headers.common['x-gp-version'] = VITE_GP_VERSION;
    try {
        const response = await axios.get(`${baseUrl}api/v1/auth/hierarchies/value/${hierarchyId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching user hierarchy", error);
    }
}